// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import skillEntity from './entities/skill.json';
import skillMenu from '../pages/skill/menu.json';
import skillFullForm from '../pages/skill/forms/full.json';
import skillContextForm from '../pages/skill/forms/context.json';
import skillMiniForm from '../pages/skill/forms/mini.json';
import skillLookupForm from '../pages/skill/forms/lookup.json';
import skillTableView from '../pages/skill/views/table.json';
import skillStagesView from '../pages/skill/views/stages.json';
import skillCardsView from '../pages/skill/views/cards.json';
import skillInlineView from '../pages/skill/views/inline.json';
import skillBacklogView from '../pages/skill/views/backlog.json';
import skillSplitView from '../pages/skill/views/split.json';
import skillCalendarView from '../pages/skill/views/calendar.json';
import skillDashboardView from '../pages/skill/views/dashboard.json';

/** Тип запису «Навичка» зі сторінками пакета: меню, форми та подання з pages/skill/. */
export const skillDefinition: IRecordTypeDefinition = {
  ...skillEntity,
  views: assembleViewSet({
      table: skillTableView,
      stages: skillStagesView,
      cards: skillCardsView,
      inline: skillInlineView,
      backlog: skillBacklogView,
      split: skillSplitView,
      calendar: skillCalendarView,
      dashboard: skillDashboardView,
  }),
  form: skillFullForm,
  forms: { full: skillFullForm, context: skillContextForm, mini: skillMiniForm, lookup: skillLookupForm },
  menu: skillMenu,
} as IRecordTypeDefinition;
